import React, { createContext, useState, useEffect } from "react";
import axios from "axios";
import { toast } from "react-toastify";

// Create the context
export const CmsContext = createContext();

// Provider Component
export const CmsProvider = ({ children }) => {
  const [cmsData, setCmsData] = useState({
    aboutUs: "There is no data in About Us",
    terms: "These is no data in Terms",
    whatWeDo: "There is no data in What We Do",
    privacyPolicy: "There is no data in privacy",
    facebookLink: "https://facebook.com",
    instagramLink: "https://instagram.com",
    youtubeLink: "https://youtube.com",
    phoneNumber: "234-123-1234",
  });
  const [loading, setLoading] = useState(true);
  const [showToast, setShowToast] = useState(false);
  // Fetch CMS data from the API
  const fetchCmsData = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}cms/`);
      if (
        response.data &&
        JSON.stringify(response.data) !== JSON.stringify(cmsData)
      ) {
        setCmsData(response.data);
        setShowToast(false);
      }
      setLoading(false);
    } catch (error) {
      // Check if error has a response (means server responded)
      if (error.response) {
        // Handle specific status codes
        if (error.response.status === 404) {
          console.error("Error 404: CMS data not found!");
          if (!showToast) {
            toast.error("Data Not Found");
            setShowToast((prev) => !prev);
          }
        } else {
          console.error(`Error ${error.response.status}:`, error.response.data);
          toast.error(`Failed to fetch CMS data! (${error.response.status})`);
        }
      } else if (error.request) {
        // Request was made but no response received
        console.error("No response received from the server:", error.request);
        toast.error("No response from server. Check your network connection.");
      } else {
        // Something else caused the error
        console.error("Error during request setup:", error.message);
        toast.error("Error fetching CMS data!");
      }

      setLoading(false);
    }
  };

  // Save CMS data to the API
  const saveCmsData = async (data) => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        toast.error("Authorization token is missing!");
        return;
      }
      const response = await axios.put(
        `${process.env.REACT_APP_API_URL}cms/`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 200) {
        toast.success("CMS data saved successfully!");
        setCmsData(data); // Update local state
      } else {
        toast.error("Failed to save CMS data!");
      }
    } catch (error) {
      console.error("Error saving CMS data:", error);
      toast.error("Error saving CMS data!");
    }
  };

  // Load data on initial render
  useEffect(() => {
    if (!cmsData || Object.keys(cmsData).length === 0) {
      fetchCmsData();
    }
  }, [cmsData]);

  return (
    <CmsContext.Provider
      value={{ cmsData, setCmsData, fetchCmsData, saveCmsData, loading }}
    >
      {children}
    </CmsContext.Provider>
  );
};
